import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { StatusControllerStatusResponse } from '../responses/status-controller-status.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'legacy',
    operationId: 'status-controller-status',
    operation: '{"operationId":"status-controller-status","responses":{"200":{"content":{"application/json":{"schema":{"type":"object","additionalProperties":{"type":"string"}}}}}},"method":"get","path":"/status-controller/status"}'
  })
export class StatusControllerStatusRemoteMethod extends OpenApiRemoteMethod<StatusControllerStatusResponse, void, void> {
  public override call(): Promise<StatusControllerStatusResponse> {
    return super.call();
  }
}
